const getOrderComments = state => state.orderComments
export const isOrderCommentsLoading = state => getOrderComments(state)?.isLoading
export const isOrderCommentsLoaded = state => getOrderComments(state)?.isLoaded
export const getComments = state => getOrderComments(state)?.commentsData?.orderComments